const EmptyState = ({ activeTab, onCreatePost, isOwnProfile }) => {
  return (
    <div className="flex min-h-[400px] xs:min-h-[450px] sm:min-h-[200px] px-4 pt-12 sm:pt-16">
      <div className="text-center max-w-md mx-auto">
        {isOwnProfile ? (
          <>
            <h3 className="text-xl xs:text-2xl sm:text-3xl font-bold text-gray-900 mb-1">
              Share your words with the world
            </h3>
            <button
              onClick={onCreatePost}
              className='text-sm xs:text-base sm:text-lg text-blue-600 mb-6 xs:mb-8 leading-relaxed'
            >
              {`Write your first ${activeTab === "all" ? "post" : activeTab === "Poetry" ? "poem" : activeTab.toLowerCase()}`}
            </button>
          </>
        ) : (
          <>
            <h3 className="text-xl xs:text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
              No Posts Yet
            </h3>
            <p className="text-sm xs:text-base sm:text-lg text-gray-600 leading-relaxed">
              When they share {activeTab === "all" ? "posts" : activeTab.toLowerCase()}, they'll show up here
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default EmptyState;